import React from "react";
import LogoWhite from "../../assets/images/logo-white.png";

import InstagramIcon from "../../assets/images/icon/instagram.svg";
// import FacebookIcon from "../../assets/images/icon/facebook.svg";
import MailIcon from "../../assets/images/icon/mail.svg";
import { useTranslation } from "react-i18next";

export default function Footer({ top = 40 }) {
    const { t } = useTranslation();
    // get current url path
    const pathname = window.location.pathname;
    console.log('pathname', pathname);
    // const navbarData = t("navbar", { returnObjects: true });
    const isAlternateFooter = () => {
        if (pathname === '/information/faq') {
            return true;
        } else if (pathname === '/information/rules-regulations') {
            return true;
        } else {
            return false;
        }
    }
    return (
        <footer className={`w-full h-full ${isAlternateFooter() ? 'bg-brandYellow' : 'bg-brandBlue'} relative z-30`}>
            <div className="2xl:px-0 md:px-14 px-0">
                <div className="container mx-auto">
                    <div className="flex md:flex-row flex-col items-center justify-between py-20 md:px-0 px-2 gap-y-10">
                        <div>
                            <img src={LogoWhite} alt="" className="w-24 2xl:w-52 md:w-40" />
                        </div>
                        <div className="grid grid-cols-1 md:gap-20">
                            {/* <div className="text-white font-poppins space-y-6">
                                <h1 className="font-bold uppercase 2xl:text-lg text-sm">
                                    {t("footer.page")}
                                </h1>
                                <ul className="space-y-2 font-light 2xl:text-base text-xs">
                                    {navbarData.map((value, index) => {
                                        return value.isHide === false ? (
                                            <li key={index}>
                                                <a href={value.href}>{value.label}</a>
                                            </li>
                                        ) : null;
                                    })}
                                </ul>
                            </div> */}
                            <div className="text-white font-poppins space-y-6">
                                {/* <h1 className="font-bold uppercase 2xl:text-lg text-sm">
                                    {t("footer.social")}
                                </h1> */}
                                <ul className="space-y-4 font-light 2xl:text-base text-xs">
                                    <li>
                                        <a
                                            href="https://instagram.com/bandoeng10k"
                                            target="_blank"
                                            rel="noreferrer"
                                            className={`flex items-center gap-x-2 font-semibold ${isAlternateFooter() ? 'text-black' : 'text-white'}`}
                                        >
                                            <img src={InstagramIcon} alt="" className="w-6" />
                                            bandoeng10k
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a
                                            href="https://facebook.com/Semarang10K"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="flex items-center gap-x-2"
                                        >
                                            <img src={FacebookIcon} alt="" className="w-6" />
                                            Semarang10K
                                        </a>
                                    </li> */}
                                    <li>
                                        <a
                                            href="mailto:info@bandoeng10k.com"
                                            target="_blank"
                                            rel="noreferrer"
                                            className={`flex items-center gap-x-2 font-semibold ${isAlternateFooter() ? 'text-black' : 'text-white'}`}
                                        >
                                            <img src={MailIcon} alt="" className="w-6" />
                                            info@bandoeng10k.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
